// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import { BASE_CONFIG } from '@iheartjane/reefer';
import type { CustomThemeConfig } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

import { useThemeGenerator } from '@jane/kiosk/hooks';
import { KioskThemeProvider } from '@jane/kiosk/providers/lib/KioskThemeProvider';

import { Layout } from './Layout/Layout';

export const MobileLayout = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  const generatedTheme = useThemeGenerator(theme.colors.primary.main);
  // Replace the Kiosk typography variants with the base Reefer variants
  const mobileTheme: CustomThemeConfig = {
    ...generatedTheme,
    components: {
      ...generatedTheme.components,
      Typography: {
        ...generatedTheme.components?.Typography,
        variants: BASE_CONFIG.components.Typography.variants,
      },
    },
  };
  return (
    <KioskThemeProvider theme={mobileTheme} themeId="mobile-theme">
      <Layout id="mobile-theme" passwordProtected={false}>
        {children}
      </Layout>
    </KioskThemeProvider>
  );
};
